import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  MdDashboard,
  MdShoppingCart,
  MdManageAccounts,
  MdStore,
} from "react-icons/md";
import { BiPackage } from "react-icons/bi";
import { FaDigitalTachograph } from "react-icons/fa";

import WarehouseProfileModal from "./Components/ProfileModal/WarehouseProfileModal";
import Navbar from "./Navbar";

export const WAREHOUSE_NAV_ITEMS = [
  {
    url: "/warehouse-dashboard",
    label: "Dashboard",
    i18nKey: "nav:dashboard",
    name: "",
    icon: MdDashboard,
  },
  {
    url: "/warehouse-orders",
    label: "Orders",
    i18nKey: "nav:orders",
    name: "shipper.access.order.view",
    icon: MdShoppingCart,
  },
  {
    url: "/warehouse-clients",
    label: "Clients",
    i18nKey: "nav:clients",
    name: "",
    icon: MdManageAccounts,
  },
  {
    url: "/warehouse-products",
    label: "Products",
    i18nKey: "nav:products",
    name: "shipper.access.product.view",
    icon: BiPackage,
  },
  {
    url: "/warehouse-payments",
    label: "Finances",
    i18nKey: "nav:finances",
    name: "shipper.access.payment.view",
    icon: FaDigitalTachograph,
  },
  {
    url: "/storage-locations",
    label: "Storage",
    i18nKey: "nav:storage",
    name: "",
    icon: MdStore,
  },
];

export const WAREHOUSE_HELPER_ALLOWED_URLS = [
  "/warehouse-orders",
  "/warehouse-products",
  "/warehouse-payments",
];

const WarehouseNavBar = () => {
  const user = useSelector((state) => state.user);
  const isOwner = !user?.parent_id;

  const navItems = useMemo(
    () =>
      isOwner
        ? WAREHOUSE_NAV_ITEMS
        : WAREHOUSE_NAV_ITEMS.filter(
            (item) =>
              WAREHOUSE_HELPER_ALLOWED_URLS.includes(item.url) &&
              item.name &&
              user?.mergedPermissions?.includes(item.name),
          ),
    [isOwner, user?.mergedPermissions],
  );

  const profileModal = ({ onClose }) => (
    <WarehouseProfileModal
      onClose={onClose}
      style={{ top: "50px", right: "0 " }}
    />
  );

  return (
    <>
      <Navbar
        navItems={navItems}
        profileImage={user?.profile_image}
        profileModal={profileModal}
      />
    </>
  );
};

export default WarehouseNavBar;
